import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { LocationContext } from "contexts/LocationProvider"
import { ClosetLocation } from "lib/utils"
import Image from "next/image"
import Link from "next/link"
import { useContext } from "react"
import { trackMapMoreInfoStation, trackMapNavigationToDest } from "reusable/ChargeGTM"
import { LeftArrowShort, LocationIcon, Mobile, NewText } from "ui"
import { getLogoByName } from "./logo"

const LocationCont = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  color: #0050c9;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  gap: 4px;
`

const StyledSwiperCard = styled.div`
  margin: 0;
  cursor: pointer;
  min-height: 0;
  box-sizing: border-box;
  border-radius: 12px;
//   width: 234px;
  background-color: white;
  border: 1px solid rgba(21, 62, 105, 0.3);
  padding: 8px 5px 0px 5px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 100px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    height: 120px;
    // width: 230px;
  }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
    padding: 12px 5px 0px 5px;
    }
    height: 120px;
    // width: 100%;
  }

`

const CardDesc = styled.div``

const StyledCardBody = styled.div`
    display: flex;
    gap: 16px;
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
        border-bottom: 1px dashed rgba(186,210,212,0.9);
        padding-bottom: 8px;
    }
`
const StyledCardFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
        padding-top: 5px;
    }
`

const StyledCardLogo = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 58px;
  height: 58px;
  border-radius: 8px;
`

const StyledDestination = styled.div`
  display: flex;
  align-items: center;
  svg {
    path {
      stroke: #0050c9;
    }
  }
  a {
    color: #0050c9;
    text-decoration: none;
  }
`
interface SwiperCardProps {
    location: ClosetLocation
    onClick: () => void
}

const SwiperCard = ({ location, onClick }: SwiperCardProps) => {

    const { selectedLocation, setMobileDetails } = useContext(LocationContext)
    if (!selectedLocation) {
        return null
    }
    const handleExtraInfoClicked = () => {
        setMobileDetails(true)
        trackMapMoreInfoStation(location.name)
    }
    return (
        <StyledSwiperCard onClick={onClick} tabIndex={0}>
            <StyledCardBody>
                <StyledCardLogo>
                    <Image
                        fill
                        alt="פז"
                        src={getLogoByName(location.name, location.metaData)}
                    />
                </StyledCardLogo>
                <CardDesc>
                    <NewText
                        component="h3"
                        largeDesktopFontSize={20}
                        largeDesktopLineHeight="28px"
                        desktopFontSize={14}
                        desktopLineHeight={"20px"}
                        desktopFontWeight="500"
                        mobileFontSize={18}
                        mobileFontWeight={500}
                    >
                        {location.name}
                    </NewText>
                    <LocationCont>
                        <NewText
                            component="p"
                            largeDesktopFontSize={16}
                            largeDesktopLineHeight="24px"
                            desktopFontSize={12}
                            desktopLineHeight={"18px"}
                            desktopFontWeight="400"
                            mobileFontSize={14}
                            mobileFontWeight={400}
                        >
                            {location.address}
                        </NewText>
                        {location.distance > 0 && (
                            <NewText
                                component="p"
                                largeDesktopFontSize={16}
                                largeDesktopLineHeight="24px"
                                desktopFontSize={12}
                                desktopLineHeight={"18px"}
                                desktopFontWeight="400"
                            >
                                {location.distance}{" "}
                                קמ׳
                            </NewText>
                        )}
                    </LocationCont>
                </CardDesc>
            </StyledCardBody>
            <Mobile>
                <StyledCardFooter>
                    <StyledButton onClick={handleExtraInfoClicked}>
                        מידע נוסף
                        <LeftArrowShort width={28} height={20} color="#0050c9" />
                    </StyledButton>
                    <StyledDestination>
                        <LocationIcon />
                        <Link
                            href={`https://waze.com/ul?ll=${location.geoLocation.latitude},${location.geoLocation.longitude}`}
                            target="blank"
                            onClick={() => trackMapNavigationToDest(location.name)}
                        >
                            ניווט ליעד
                        </Link>
                    </StyledDestination>
                </StyledCardFooter>
            </Mobile>
        </StyledSwiperCard>
    )
}

export default SwiperCard;
